
// export function translate(key: LabelKey, language?: 'en' | 'zh'): string {
//   const lang = language || getCurrentLanguage();
//   return LABELS[key]?.[lang] || key;
// }


export function tokenizeString(input: string): string {
  // If the input is already in camelCase (no spaces, starts with lowercase), return as-is
  if (!/\s/.test(input) && /^[a-z]/.test(input)) {
    return input;
  }
  
  // Remove content in parentheses, then split by spaces, commas, slashes, and other delimiters
  // Convert to camelCase
  return input
    .replace(/\([^)]*\)/g, '') // Remove parentheses and their content
    .split(/[\s,\-\/]+/) // Split by spaces, commas, hyphens, slashes FIRST
    .map(word => word.replace(/[^\w]/g, '')) // Then remove any remaining symbols from each word
    .filter(word => word.length > 0) // Remove empty strings
    .map((word, index) => {
      // First word is lowercase, rest are capitalized
      if (index === 0) {
        return word.charAt(0).toLowerCase() + word.slice(1).toLowerCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join('');
}
